module.exports = __webpack_public_path__ + "static/travelers_clothes-bdd84247d60586f6dd148c5f8dacdf92.jpg";